import React from "react";
import Jackeline from "../images/contenido/CharlaJaramillo1.jpg";
import Wilber from "../images/contenido/Taller descentralizado con el periodista Wilber Huacasi en Moquegua.jpg";
import Leon from "../images/contenido/FM LAURA LEON-SDARC-abridora_edited.jpg";

import { Link } from "react-router-dom";
import { Fade } from "react-awesome-reveal";

const C2Periodismo = () => {
  return (
    <section id="periodismo" className="nosotros bg-blue-dark">
      <Fade delay={100} triggerOnce>
        <div className="block-circle"></div>
        <div className="container d-flex">
          <div className="images">
            <img src={Jackeline} alt="Charla Jaramillo" className="mohme-1" />
            <img
              src={Wilber}
              alt="Equipo Fundacion Gustavo Mohme Llona"
              className="mohme-2"
            />
            <img
              src={Leon}
              alt="Familia Fundacion Gustavo Mohme Llona"
              className="mohme-3"
            />
          </div>
          <div className="text">
            <h3 className="section-title">2. EJE PERIODISMO Y DEMOCRACIA</h3>
            <div className="block-transparent"></div>
            <p>
              Iniciativa que parte de la necesidad de fortalecer la ética
              periodística en los profesionales y estudiantes de la
              comunicación, especialmente en regiones. Promueve un periodismo de
              calidad e incisivo, el acceso a material informativo de valor para
              la comunidad y una actitud cuestionadora en la opinión pública. De
              esta manera, busca velar por el buen funcionamiento del sistema
              democrático de nuestro país. Se materializa por medio de distintos
              proyectos.
            </p>
            <div>
              <div className="button-link">
                <Link to="/talleres-periodismo">
                  2.1 Talleres sobre periodismo (actividades de formación)
                </Link>
              </div>
              <div className="button-link">
                <Link to="/observatorio-universitario-medios">
                  2.2 Observatorio Universitario de Medios
                </Link>
              </div>
              <div className="button-link">
                <Link to="/cultura-digital">
                  2.3 Sociedad de la información y cultura digital para la
                  ciudadanía
                </Link>
              </div>
            </div>
          </div>
        </div>
      </Fade>
    </section>
  );
};

export default C2Periodismo;
